const version = "2.10.2";

export { version };
//# sourceMappingURL=version.mjs.map
